import { render, staticRenderFns } from "./OrderPaymentResult.vue?vue&type=template&id=a665d424"
import script from "./OrderPaymentResult.vue?vue&type=script&lang=js"
export * from "./OrderPaymentResult.vue?vue&type=script&lang=js"
import style0 from "./OrderPaymentResult.vue?vue&type=style&index=0&id=a665d424&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports